import BASE_64_TRANSPARENT_GIF_SRC from '../../../constants/base64TransparentGifSrc';
import SVGIcon from './../SVGIcon';

export const iconPlaceholder = props => (
  <SVGIcon width={48} height={48} {...props}>
    <image xlinkHref={BASE_64_TRANSPARENT_GIF_SRC} />
  </SVGIcon>
);
